var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "pt-status" }, [_c('div', { staticClass: "pt-status-inner" }, [_c('span', { class: _vm.statusClass }), _vm._v(" "), _c('span', { staticClass: "status-text" }, [_vm._v(_vm._s(_vm.text))])])]);
};
var staticRenderFns = [];

export { render, staticRenderFns };